import { dateV2Service } from '../../value-object/DateV2'

export type SprintStatus = 'STANDBY' | 'INPROGRESS' | 'FINISHED' | 'CANCELED'

/** プロジェクト計画のスプリント列と同じ並び。 */
export const SPRINT_STATUS_DISPLAY_ORDER: SprintStatus[] = [
  'INPROGRESS',
  'STANDBY',
  'FINISHED',
  'CANCELED',
]

export const SPRINT_DEFAULT_COLLAPSED_STATUSES: SprintStatus[] = [
  'FINISHED',
  'CANCELED',
]

const statusOrder = (status: SprintStatus | undefined): number => {
  const index = status ? SPRINT_STATUS_DISPLAY_ORDER.indexOf(status) : -1
  return index < 0 ? SPRINT_STATUS_DISPLAY_ORDER.length : index
}

export const sortSprintsByStatusAndNum = <
  T extends { status?: SprintStatus; num: number },
>(
  sprints: T[]
): T[] =>
  [...sprints].sort((a, b) => {
    const statusDiff = statusOrder(a.status) - statusOrder(b.status)
    if (statusDiff !== 0) return statusDiff
    return a.num - b.num
  })

export const formatSprintLabel = (
  sprintName: string,
  startDate: string | undefined,
  endDate: string | undefined
): string => {
  const start = dateV2Service.fromString(startDate)
  const end = dateV2Service.fromString(endDate)
  if (!start || !end) return sprintName
  return `${sprintName}（${dateV2Service.formatMonthAndDate(start)}～${dateV2Service.formatMonthAndDate(end)}）`
}
